// noinspection ES6CheckImport

import { initializeApp } from 'firebase/app';
import {connectFirestoreEmulator, getFirestore} from 'firebase/firestore';
import {connectAuthEmulator, getAuth} from "firebase/auth";
import {connectFunctionsEmulator, getFunctions} from "firebase/functions";
import { getMessaging } from "firebase/messaging";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
}

const app = initializeApp(firebaseConfig)

const firestore = getFirestore(app)
const auth = getAuth(app)
const functions = getFunctions(app)
const messaging = getMessaging(app)
const storage = getStorage(app)

// if (process.env.NODE_ENV !== 'production') {
//   // Set up emulators
//   connectFirestoreEmulator(firestore, 'localhost', 8080)
//   connectAuthEmulator(auth, 'http://localhost:9099')
//   connectFunctionsEmulator(functions, "localhost", 5001)
// }

export default app;

export {
  firebaseConfig,
  auth,
  firestore,
  functions,
  messaging,
  storage
};
